import { Card } from './card';

interface ICardComponentProps {
  cardFooter?: React.ReactNode;
}

const withCardComponent =
  <T extends object>(Component: React.FC<T>) =>
  ({ cardFooter, ...props }: T & ICardComponentProps) => {
    return (
      <Card {...props}>
        <Component {...(props as T)} />
        {cardFooter}
      </Card>
    );
  };

export const withCard = <T extends object>(
  Component: React.FC<T>
): React.FC<T & ICardComponentProps> => {
  return withCardComponent(Component);
};
